import { apiSuccess, apiList } from '@services/apiSchemas';
import {
  ProductSerialNumberDetailSchema,
  ProductSerialNumberRecordSchema,
} from '@services/shared/productSerialNumberSchemas';

import adminApiFetch from './apiService';

// Schema 與 type 全部來自 @services/shared/productSerialNumberSchemas
// 兩端 response shape 一致（差異僅在 server-side base_scope），共用避免手動同步漂移。
export type {
  ProductSerialNumberDetail,
  ProductSerialNumberInventory,
  ProductSerialNumberRecord,
  ProductSerialNumberStatus,
  ProductSerialNumberTimelineEvent,
  ProductSerialNumberTimelineEventType,
} from '@services/shared/productSerialNumberSchemas';

const productSerialNumberService = {
  // 列表（PSN 識別中心查詢）
  // params 接受 numbers[] / product_ids[] / status[] / page / page_size
  getRecords: async (params: Record<string, unknown> = {}) => {
    const res = await adminApiFetch('product_serial_numbers/get_records', {
      method: 'POST',
      body: params,
    });
    return apiList(ProductSerialNumberRecordSchema).parse(await res.json());
  },

  // 詳細（含 timeline）
  getById: async (id: string) => {
    const res = await adminApiFetch(`product_serial_numbers/${id}`, {
      method: 'GET',
    });
    return apiSuccess(ProductSerialNumberDetailSchema).parse(await res.json());
  },
};

export default productSerialNumberService;
